/**
 * Ksting
 *
 * Copyright © 2020 Rana Terning. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import { shape, string } from 'prop-types';
import moment from 'moment';
import { createUrl } from 'utils/urlHelper';
import Button from 'components/Button/Button';
import InformationBox from 'components/InformationBox/InformationBox';
import classNames from 'clsx';

import styles from './job-card.scss';

const JobCard = ({ job }) => {
  const {
    title,
    date_starts,
    date_ends,
    location,
    job_id,
    team_discussion_id,
  } = job;

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <InformationBox title="Project name:" text={title} />
        <InformationBox
          title="Dates:"
          text={`${moment(date_starts).format('MMM DD, YYYY')} - ${moment(
            date_ends
          ).format('MMM DD, YYYY')}`}
        />
        <InformationBox title="Location:" text={location} />
      </div>
      <div className={styles.buttonWrapper}>
        <Button
          className={styles.button}
          ghost
          dark
          small
          path={createUrl('jobEdit', job_id)}
        >
          Edit project
        </Button>
        {team_discussion_id && (
          <Button
            className={classNames(styles.button, styles.teamChatId)}
            ghost
            dark
            small
            path={createUrl('message', team_discussion_id)}
          >
            Team chat
          </Button>
        )}
      </div>
    </div>
  );
};

/**
 * Declare expected property types.
 *
 * @type {Object}
 */
JobCard.propTypes = {
  job: shape({
    title: string.isRequired,
    date_starts: string.isRequired,
    date_ends: string.isRequired,
    location: string.isRequired,
    job_id: string.isRequired,
    team_discussion_id: string,
  }),
};

JobCard.defaultProps = {
  team_discussion_id: '',
};

export default JobCard;
